import "./styles.css";
import { Col, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { List } from "antd";
import { ORG_TYPES } from "../../Common/Constants";
import { useLocalFetch } from "../../../hooks/useLocalFetch";
import { useRequiredAccess } from "../../../hooks/useRequiredAccess";

const Competitors = () => {
  const [filterTimeRange, setFilterTimeRange] = useState("9_m");
  const checkAccess = useRequiredAccess(
    [],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );
  const data =  useLocalFetch("./sankeyCharts/competitorData.json");
  useEffect(() => {
    checkAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickHandler = (event, url) => {
    event.preventDefault();
    window.open(url, "_blank", "noreferrer");
  };

  const updateTimeRange = (value) => {
    setFilterTimeRange(value);
  };

  return (
    <Row
      gutter={16}
      className="competitor-issue-page"
      style={{
        justifyContent: "center",
      }}
    >
      <Col
        style={{
          justifyContent: "center",
          width: "60%",
        }}
      >
        <List
          header={<div className="title">Competitor Issues</div>}
          className="list"
          bordered
          dataSource={data?.competitorData}
          renderItem={(item, index) => (
            <List.Item>
                <div className="w100 flex-between">
                  <Link
                    to={item.link}
                    onClick={(e) => onClickHandler(e, item.link)}
                    className="content"
                    >
                      <div style={{color:item.color}}>{item.text}</div>
                  </Link>
                  <div>
                    <Select
                      placeholder="Select a time range"
                      data-testid="alert-timerange-dropdown"
                      value={filterTimeRange}
                      style={{ width: "200px" }}
                      onChange={updateTimeRange}
                    >
                      <Select.Option value="1_m" disabled>last 3 months</Select.Option>
                      <Select.Option value="6_m" disabled>last 6 months</Select.Option>
                      <Select.Option value="9_m">last 9 months</Select.Option>
                    </Select>
                  </div>
                </div>
            </List.Item>
          )}
        />
      </Col>
    </Row>
  );
};

export default Competitors;
